import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { Gift, ArrowRight } from 'lucide-react';
export function FreeSessionCTA() {
  return <Section id="contact" background="blush" className="text-center" data-id="element-88">
      <Card className="max-w-4xl mx-auto bg-white shadow-xl border-none overflow-hidden relative" data-id="element-89">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-primary via-brand-secondary to-brand-accent" data-id="element-90"></div>

        <div className="p-8 md:p-12" data-id="element-91">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-secondary/20 text-brand-primary mb-6" data-id="element-92">
            <Gift className="w-8 h-8" data-id="element-93" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-6" data-id="element-94">
            Sesiune CADOU de Evaluare 1 la 1
          </h2>

          <div className="grid md:grid-cols-3 gap-8 text-left mb-10 max-w-3xl mx-auto" data-id="element-95">
            <div className="flex flex-col items-center text-center p-4 bg-brand-bg rounded-lg" data-id="element-96">
              <span className="text-brand-primary font-bold text-lg mb-2" data-id="element-97">
                Clarificăm
              </span>
              <p className="text-sm text-gray-600" data-id="element-98">
                Ce te apasă acum (anxietate, frici, blocaje, relații)
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4 bg-brand-bg rounded-lg" data-id="element-99">
              <span className="text-brand-primary font-bold text-lg mb-2" data-id="element-100">
                Identificăm
              </span>
              <p className="text-sm text-gray-600" data-id="element-101">
                “Rădăcina” problemelor, nu doar simptomele
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4 bg-brand-bg rounded-lg" data-id="element-102">
              <span className="text-brand-primary font-bold text-lg mb-2" data-id="element-103">
                Direcția
              </span>
              <p className="text-sm text-gray-600" data-id="element-104">
                Îți spun exact ce ți se potrivește: 1:1 / atelier / curs
              </p>
            </div>
          </div>

          <Button variant="accent" size="lg" className="mb-6 group" data-id="element-105">
            Rezervă Sesiunea CADOU
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-106" />
          </Button>

          <p className="text-sm text-gray-500 italic max-w-lg mx-auto" data-id="element-107">
            Dacă simți că ai încercat multe și încă ești în același loc, nu e
            despre voință. E despre metodă și susținere.
          </p>
        </div>
      </Card>
    </Section>;
}